import o from "./ghl-ui.es1235.js";
import t from "./ghl-ui.es728.js";
var a = o(t, "Map");
const e = a;
export {
  e as default
};
